import {
  ContractorAdditionalSettingsResponse,
  Owner,
} from "@/models/api/administration/contractors/ContractorAdditionalSettingsResponse";
import CancellableHelper from "@/requests/CancellableHelper";
import { ContractorProviderIdentity } from "@/models/api/administration/contractors/ContractorProviderIdentity";

export const URL_GET_CONTRACTOR_ADDITIONAL_SETTINGS = "/ContractorAdministration/${ContractorId}/AdditionalSettings";
export const URL_POST_EDIT_CONTRACTOR_COMMENT = "/ContractorAdministration/${ContractorId}/Comment";
export const URL_POST_SAVE_SUMMARY_PRINT_SETTING = "/ContractorAdministration/${ContractorId}/SummaryPrint";
export const URL_POST_EDIT_CONTRACTOR_OWNERS = "/ContractorAdministration/${ContractorId}/EditOwners";
export const URL_POST_LOCK_CONTRACTOR = "/ContractorAdministration/${ContractorId}/Lock";
export const URL_POST_UNLOCK_CONTRACTOR = "/ContractorAdministration/${ContractorId}/Unlock";
export const URL_POST_EDIT_SHOW_EXCHANGE_PURCHASE_INFORMATION_ON_INVOICE =
  "/ContractorAdministration/${ContractorId}/EditShowExchangePurchaseInformationOnInvoice";
export const URL_POST_EDIT_CONTRACTOR_PROVIDER_IDENTITY =
  "/ContractorAdministration/${ContractorId}/EditContractorProviderIdentity";
export const URL_POST_EDIT_CONTRACTOR_SYMBOLS_JPK = "/ContractorAdministration/${ContractorId}/SymbolsJPK";
export const URL_POST_SAVE_PAYMENT_METHOD_RESTRICTION =
  "/ContractorAdministration/${ContractorId}/PaymentMethodRestriction";

const _getContractorAdditionalSettings = new CancellableHelper<ContractorAdditionalSettingsResponse>(
  URL_GET_CONTRACTOR_ADDITIONAL_SETTINGS,
  ContractorAdditionalSettingsResponse
);
export const getContractorAdditionalSettings = async (
  contractorId: string
): Promise<ContractorAdditionalSettingsResponse> => {
  return await _getContractorAdditionalSettings.get({
    ContractorId: contractorId,
  });
};

const _editContractorComment = new CancellableHelper<null>(URL_POST_EDIT_CONTRACTOR_COMMENT, null, true);
export const editContractorComment = async (contractorId: string, comment: string): Promise<null> => {
  return await _editContractorComment.post({ ContractorId: contractorId }, comment);
};

const _savePaymentMethodRestriction = new CancellableHelper<null>(URL_POST_SAVE_PAYMENT_METHOD_RESTRICTION, null, true);
export const savePaymentMethodRestriction = async (
  contractorId: string,
  isPaymentMethodRestricted: boolean
): Promise<null> => {
  return await _savePaymentMethodRestriction.post({
    ContractorId: contractorId,
    isPaymentMethodRestricted,
  });
};

const _saveSummaryPrintSetting = new CancellableHelper<null>(URL_POST_SAVE_SUMMARY_PRINT_SETTING, null, true);
export const saveSummaryPrintSetting = async (contractorId: string, summaryPrint: boolean): Promise<null> => {
  return await _saveSummaryPrintSetting.post({
    ContractorId: contractorId,
    summaryPrint,
  });
};

const _saveShowExchangePurchaseInformationOnInvoice = new CancellableHelper<null>(
  URL_POST_EDIT_SHOW_EXCHANGE_PURCHASE_INFORMATION_ON_INVOICE,
  null,
  true
);
export const saveShowExchangePurchaseInformationOnInvoice = async (
  contractorId: string,
  showExchangePurchaseInformationOnInvoice: boolean
): Promise<null> => {
  return await _saveShowExchangePurchaseInformationOnInvoice.post(
    { ContractorId: contractorId },
    showExchangePurchaseInformationOnInvoice
  );
};

const _saveContractorProviderIdentity = new CancellableHelper<null>(
  URL_POST_EDIT_CONTRACTOR_PROVIDER_IDENTITY,
  null,
  true
);
export const saveContractorProviderIdentity = async (
  contractorId: string,
  contractorProviderIdentity: ContractorProviderIdentity
): Promise<null> => {
  return await _saveContractorProviderIdentity.post(
    {
      ContractorId: contractorId,
    },
    contractorProviderIdentity
  );
};

const _saveSymbolsJPK = new CancellableHelper<null>(URL_POST_EDIT_CONTRACTOR_SYMBOLS_JPK, null, true);
export const saveSymbolsJPK = async (contractorId: string, symbolsJPK: string | null): Promise<null> => {
  return await _saveSymbolsJPK.post({ ContractorId: contractorId }, symbolsJPK);
};

const _editContractorOwners = new CancellableHelper<null>(URL_POST_EDIT_CONTRACTOR_OWNERS, null, true);
export const editContractorOwners = async (contractorId: string, owners: Array<Owner>): Promise<null> => {
  return await _editContractorOwners.post({ ContractorId: contractorId }, owners);
};

const _lockContractor = new CancellableHelper<null>(URL_POST_LOCK_CONTRACTOR, null, true);
export const lockContractor = async (contractorId: string, comment: string): Promise<null> => {
  return await _lockContractor.post({ ContractorId: contractorId }, comment);
};

const _unlockContractor = new CancellableHelper<null>(URL_POST_UNLOCK_CONTRACTOR, null, true);
export const unlockContractor = async (contractorId: string, comment: string): Promise<null> => {
  return await _unlockContractor.post({ ContractorId: contractorId }, comment);
};
